// extracted by mini-css-extract-plugin
module.exports = {"box":"OrdersMobileSkeleton_box__qe3ia"};